import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';
import VehiclesRecords from '@/components/vehicles/VehiclesRecords';
import VehicleSheet from '@/components/vehicles/VehicleSheet';

export default function VehiclesRecordsPage() {
  const [sheetOpen, setSheetOpen] = useState(false);
  const [selectedVehicleId, setSelectedVehicleId] = useState<number | null>(null);

  const openCreateSheet = () => {
    setSelectedVehicleId(null);
    setSheetOpen(true);
  };

  return (
    <div className="space-y-6 animate-fade-in px-4 sm:px-6 lg:px-8 pt-6">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="text-4xl font-semibold tracking-tight mb-2">Vehicle Records</h1>
          <p className="text-muted-foreground">View and manage fleet vehicles, registrations, and contracts.</p>
        </div>
        <Button onClick={openCreateSheet}>
          <Plus className="h-4 w-4 mr-1" />
          Add Vehicle
        </Button>
      </div>

      <VehiclesRecords group="all" />

      <VehicleSheet
        open={sheetOpen}
        onOpenChange={setSheetOpen}
        vehicleId={selectedVehicleId}
      />
    </div>
  );
}
